import React, { PropTypes } from 'react';
import _ from 'underscore';

import ToolTip from './ToolTip';

const TextInputGroup = ({ label, toolTip, ...otherProps }) => (
    <p>
        {!_.isNull(label) ?
            <label>
                {label}
                {!_.isUndefined(toolTip) ? <ToolTip text={toolTip} /> : null}
            </label>
        : null }
        <input {...otherProps} />
    </p>
);

TextInputGroup.propTypes = {
    label: PropTypes.string,
    toolTip: PropTypes.string
};

export default TextInputGroup;



/** WEBPACK FOOTER **
 ** ./src/elements/TextInputGroup.js
 **/